import { render } from "./Pessoas.vue?vue&type=template&id=3ec8c4b4"
import script from "./Pessoas.vue?vue&type=script&lang=js"
export * from "./Pessoas.vue?vue&type=script&lang=js"

import "./Pessoas.vue?vue&type=style&index=0&id=3ec8c4b4&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__